<div class="container">
    <div class="col-md-12 lease_table">
        <div>
            <div class="d-flex list">
                <div class="migration_detials">Counselling Report</div>
                <div class="migration_detials1" (click)="openfilterdialog()">Filter List</div>
            </div>
            <div class="col-md-12">
                <section class="section_one" *ngIf="rowData?.length === 0">
                    <div class="cctvcouncelling__sec">
                        <div class="councellist__flex">
                            <div>
                                <div class="nodata_center">
                                    <figure class="mb-0">
                                        <img src="../../assets/image/nodata.png " alt="nodata" class="nodata">
                                    </figure>
                                    <p class="no_data">No Data Found</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section *ngIf="rowData && rowData.length > 0">
                    <div class="table_data">
                        <button (click)="onBtExport()" class="mb-2">
                            Download Excel</button>
                        <ag-grid-angular style="width: 100%; height: 500px;" class="ag-theme-alpine" [rowData]="rowData"
                            [columnDefs]="columnDefs" [pagination]="true" [paginationPageSize]="10"
                            [quickFilterText]="quickFilter" [defaultExcelExportParams]="defaultExcelExportParams"
                            (gridReady)="onGridReady($event)">
                        </ag-grid-angular>
                    </div>
                </section>
            </div>
        </div>
    </div>
</div>


<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>